/**
 * anasayfaWidgetDurumu.js — firma portalı Ana Sayfa'sındaki widget durumunun (açık / kapalı paneller, gizli widget'lar, sütun
 * düzeni) KULLANICIYA göre saklanması (backlog #433, 2026-10-16). FirmaAnasayfaListPage.jsx kullanır; mantık sayfadan ayrı ki
 * jest ile denenebilsin (anasayfaWidgetDurumu.test.js).
 *
 * Eskiden iki ortak localStorage anahtarı vardı (firmaAnasayfaHiddenWidgets, firmaAnasayfaWidgetLayout): aynı tarayıcıda iki
 * giriş birbirinin durumunu görüyordu, açık / kapalı durumu ise hiç saklanmıyordu. Şimdi her anahtarın sonuna GERÇEK giriş
 * yapmış kullanıcının id'si eklenir (`localStorage.userId`: getAuthHeader'ın X-user-Id'sinin okuduğu değer). Personel önizlemesi
 * (#411) bir firmayı gösterse bile bu, personelin kendi id'sidir: firma girişinin anahtarına yazılmaz. Giriş id'si yoksa hiçbir
 * şey okunmaz ya da yazılmaz. Eski ortak anahtarlar artık okunmaz (kullanıcılar düzenlerini bir kez kaybeder).
 * Sunucu tarafında kullanıcıya bağlı bir tercih (tablo + uçlar) başka cihazlara da taşırdı ama bir şema değişikliğidir: Bilge'nin kararı.
 */

export const HIDDEN_WIDGETS_STORAGE_BASE = "firmaAnasayfaHiddenWidgets";
export const LAYOUT_STORAGE_BASE = "firmaAnasayfaWidgetLayout";
export const OPEN_PANELS_STORAGE_BASE = "firmaAnasayfaOpenPanels";

/** Yüklemeler ve İletişim açık, diğer beş widget kapalı gelir. */
export const DEFAULT_OPEN_PANELS = {
  standDurumu: false,
  yuklemeler: true,
  personeller: false,
  standlarim: false,
  projeler: false,
  talepler: false,
  iletisim: true,
};

/**
 * Arayüz seti -> o setin KENDİ varsayılan sütun düzeni (#535, 2026-10-21, Deniz): Yabancı Katılımcı'da Yüklemeler ortadaki sütunda
 * (sol sütunda firma kartının altında değil), İletişim sağda; sol sütun yalnızca firma kartı. Böyle bir setin düzeni kendi depolama
 * anahtarında saklanır (layoutDepolamaTabani), yani kullanıcının eskiden kaydedilmiş ortak düzeni onu ezmez ve öbür setler
 * etkilenmez. Geri almak için girdiyi silmek yeterli (WAS: her set tek ortak düzeni paylaşıyordu).
 * #704: `setKodu` düzenin kodudur (services/sadePanel.gorunumSetKodu): Sade panel modu AÇIKKEN her firma YABANCI_KATILIMCI anahtarını
 * okur / yazar, kendi kaydına dokunmaz; anahtar KAPANINCA kendi düzeni olduğu gibi geri gelir.
 */
export const SET_VARSAYILAN_DUZEN = {
  YABANCI_KATILIMCI: { col1: [], col2: ["yuklemeler"], col3: ["iletisim"] },
};

/** Sütun düzeninin depolama anahtarının tabanı: kendi varsayılanı olan sette `<LAYOUT>.<SET>`, aksi halde ortak anahtar. */
export const layoutDepolamaTabani = (setKodu) => (SET_VARSAYILAN_DUZEN[setKodu] ? `${LAYOUT_STORAGE_BASE}.${setKodu}` : LAYOUT_STORAGE_BASE);

/** Bu setin ilk düzeni: kullanıcının o anahtardaki kaydı, yoksa setin varsayılanı, o da yoksa `genel` (sayfanın DEFAULT_LAYOUT'u). */
export const baslangicDuzeni = (setKodu, genel) => readUserStorage(layoutDepolamaTabani(setKodu)) ?? SET_VARSAYILAN_DUZEN[setKodu] ?? genel;

/** `base:<userId>`; giriş id'si yoksa (ya da depolama okunamıyorsa) null. */
export function loggedInUserKey(base) {
  try {
    const id = localStorage.getItem("userId");
    return id ? `${base}:${id}` : null;
  } catch {
    return null;
  }
}

/** Bu kullanıcının saklı değeri, yoksa / bozuksa null. */
export function readUserStorage(base) {
  try {
    const key = loggedInUserKey(base);
    const raw = key ? localStorage.getItem(key) : null;
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Bu kullanıcının anahtarına yazar; giriş id'si yoksa ya da depolama doluysa sessizce hiçbir şey yapmaz. */
export function writeUserStorage(base, value) {
  try {
    const key = loggedInUserKey(base);
    if (key) localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // depolama dolu / kapalı: durum yalnızca bir sonraki ziyarette varsayılana döner
  }
}

/**
 * Saklı durum varsayılanların ÜSTÜNE biner: bilinmeyen anahtarlar atılır, boolean olmayan değerler yok sayılır, sonradan eklenen
 * bir widget kendi varsayılanını alır.
 */
export function reconcileOpenPanels(raw) {
  const out = { ...DEFAULT_OPEN_PANELS };
  if (raw && typeof raw === "object") {
    Object.keys(DEFAULT_OPEN_PANELS).forEach((k) => {
      if (typeof raw[k] === "boolean") out[k] = raw[k];
    });
  }
  return out;
}
